// extracted by mini-css-extract-plugin
module.exports = {"nave":"Paginado_nave__aPYl0","pagina":"Paginado_pagina__3IA2q","num":"Paginado_num__2mjOz"};